<template >
    <el-dialog title="商品发货" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true" append-to-body
        width="480px">
        <el-form ref="logisticForm" :model="logisticForm" :rules="logisticRules" label-width="82px">
            <el-form-item label="物流公司" prop="logistics_name">
                <!-- <el-input v-model="logisticForm.logistics_name" placeholder="请输入内容" /> -->
                <el-select v-model="logisticForm.logistics_name" placeholder="请选择物流公司">
                    <el-option :label="item.name" :value="item.name" v-for="item, index in logisticsList" :key="index" />
                </el-select>
            </el-form-item>
            <el-form-item label="物流单号" prop="logistics_number">
                <el-input v-model="logisticForm.logistics_number" placeholder="请输入内容" />
            </el-form-item>
            <div style="margin-left:82px">
                <el-button @click="trunOff">取消</el-button>
                <el-button type="primary" :loading="logisticSubmitting" @click="onShipping('logisticForm')">发货</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>

<script>
import { zhongcao } from "@/api/order"

export default {
    data: () => ({
        logisticRules: {
            logistics_name: [
                { required: true, message: '请输入物流公司', trigger: 'blur' }
            ],
            logistics_number: [
                { required: true, message: '请输入物流单号', trigger: 'blur' }
            ]
        },
        logisticForm: {
            order_id: null,
            logistics_name: '',
            logistics_number: ''
        },
        logisticSubmitting: false,
        logisticsList: [
            {
                name: '日本郵便',
                id: 1,
            },
            {
                name: 'ヤマト運輸',
                id: 2,
            },
            {
                name: '佐川急便',
                id: 3,
            },
            {
                name: '其他',
                id: 4,
            },
        ]
    }),
    props: {
        show: {
            default: false,
            type: Boolean
        },
        order_id: {
            required: true,
            type: String
        }
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        onShipping(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    try {
                        this.logisticSubmitting = true
                        await zhongcao.shipping(this.logisticForm)
                        this.$message({
                            message: "已发货!",
                            type: 'success'
                        });
                        this.$emit("onUpdate")
                        this.trunOff()
                    } catch {
                        this.$message.error('出错了!');
                    } finally {
                        this.logisticSubmitting = false
                    }
                }
            });
        },
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        }
    },
    created() {
        this.logisticForm.order_id = this.order_id
    }
}
</script>

<style lang="scss" scoped></style>